import {createContext} from "react";
import {BridgeToken} from "../bridge";


export interface ContextType {
    bridge?: BridgeToken;
}

const Context = createContext<ContextType>({

});
export default Context;